import { defineComponent as _defineComponent } from 'vue'
import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveComponent as _resolveComponent, createBlock as _createBlock, renderSlot as _renderSlot, createElementVNode as _createElementVNode, toHandlers as _toHandlers, mergeProps as _mergeProps, withCtx as _withCtx, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-5efce18b"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "controller-body" }
const _hoisted_2 = { class: "form-content" }

import { FormItem } from '@/types/form';
  import { watchEffect, ref } from 'vue';

  type TForm = { [key: string]: any };

  interface IProps {
    visible?: boolean;
    title?: string;
    formList: FormItem[];
    form: TForm;
  }
  interface IEmits {
    (event: 'update:visible', props: boolean): void;
    (event: 'change', form: TForm): void;
  }

  
export default /*#__PURE__*/_defineComponent({
  props: {
    visible: { type: Boolean, default: false },
    title: null,
    formList: null,
    form: null
  },
  emits: ["update:visible", "change"],
  setup(__props: any, { emit: emits }: { emit: ({
    (event: 'update:visible', props: boolean): void;
    (event: 'change', form: TForm): void;
  }), expose: any, slots: any, attrs: any }) {

const props = __props as { visible: boolean, title?: string, formList: FormItem[], form: TForm }

  
  
  const localForm = ref({});

  const handleFormChange = ({ key, value }: any) => {
    localForm.value[key] = value;
  };

  const handleConfirm = () => {
    emits('change', JSON.parse(JSON.stringify(props.form)));
    emits('update:visible', false);
  };

  const on = {
    'update:modelValue'(val: boolean) {
      emits('update:visible', val);
    }
  };

  watchEffect(
    () => {
      localForm.value = props.form;
    }
  );


return (_ctx: any,_cache: any) => {
  const _component_AppFormGroupItem = _resolveComponent("AppFormGroupItem")!
  const _component_AppOffcanvas = _resolveComponent("AppOffcanvas")!

  return (_openBlock(), _createBlock(_component_AppOffcanvas, _mergeProps({
    "model-value": __props.visible,
    title: __props.title
  }, _toHandlers(on)), {
    default: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(__props.formList, (item) => {
            return (_openBlock(), _createBlock(_component_AppFormGroupItem, {
              key: item.key,
              config: item,
              form: localForm.value,
              onChange: handleFormChange
            }, null, 8, ["config", "form"]))
          }), 128)),
          _renderSlot(_ctx.$slots, "default")
        ]),
        _createElementVNode("div", { class: "form-footer" }, [
          _createElementVNode("button", {
            class: "btn btn-primary",
            onClick: handleConfirm
          }, " Confirm ")
        ])
      ])
    ]),
    _: 3
  }, 16, ["model-value", "title"]))
}
}

})